<template>
  <div id="onboarding-selfie" class="fade-in">
    <StepInfo :showIcon="false" btnText="Continuar para a selfie" @btnClick="actionEvent">
      <h3>Envio da selfie</h3>

      <ul>
        <li>
          Procure um ambiente bem iluminado
        </li>

        <li>
          Retire boné, óculos ou qualquer acessório que esteja utilizando
        </li>
      </ul>

      <div class="onboarding-image">
        <asset-v3 dir="context" name="faceTec-selfie.svg" />
      </div>
    </StepInfo>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AssetV3 from '@/components/common/AssetV3.vue';

import StepInfo from '../components/StepInfo.vue';

export default {
  name: 'onboarding-selfie',
  components: { StepInfo, AssetV3 },
  computed: {
    ...mapState('onboarding', ['selfieFlow']),
  },
  methods: {
    actionEvent() {
      const selfieCameraRouteName = this.selfieFlow === 'FACETEC'
        ? 'onboarding-selfie-faceTec-camera'
        : 'onboarding-selfie-parcelex-camera';

      this.$router.replace({
        name: selfieCameraRouteName,
        query: this.$route.query,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  #onboarding-selfie {
    h3 {
      color: var(--gray-900);

      font-size: 24px;
      line-height: 32px;
      font-weight: 700;
    }

    ul {
      margin: 20px 0 0 20px;

      list-style-type: disc;
      color: var(--blue-400);

      font-size: 16px;
      line-height: 24px;
      font-weight: 600;
    }

    .onboarding-image {
      margin-top: 36px;
      display: flex;
      justify-content: center;
    }
  }
</style>
